<template>
  <div class="context" v-show="isshow">
    <span class="tip">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "Toast",
  props: {
    isshow: {
      type: Boolean,
    },
    text: {
      type: String,
    },
  },
  watch: {
    isshow(val) {
      if (val === true) {
        setTimeout(() => {
          this.isshow = false;
        }, 3000);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.context {
  // position: absolute;
  // top: 0;
  // left: 25%;
  // width: 50%;
  // height: 70%;
  // // z-index: 100;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 5005 !important;
  background-color: rgba(40, 40, 40, 0.8);
  padding: 20px;
    border-radius: 1rem;
  .tip {
    
    color: aliceblue;
    font-size: 12px;
    display: inline-block;
    z-index: 5005 !important;
    line-height: 20px;
    word-wrap: break-word;
    text-align: center !important;
  }
}
</style>
